<!-- Desktop Upload Area -->
<div
  class="drop-area"
  *ngIf="!isMobile"
  (dragover)="onDragOver($event)"
  (dragleave)="onDragLeave($event)"
  (drop)="onDrop($event)"
>
  <ion-icon name="cloud-upload-outline" size="large"></ion-icon>
  <ng-container *ngIf="!dataLoading.isLoading">
  <p>Choose a photo or drag & drop it here</p>
  <p>or</p>
  <ion-button (click)="selectFromDesktop()">Browse Files</ion-button>
  </ng-container>
  <div *ngIf="dataLoading.isLoading">
    <ion-spinner name="crescent"></ion-spinner>
    <div class="loading-message">{{ dataLoading.message }}</div>
  </div>
</div>

<!-- Mobile Upload Buttons -->
<div *ngIf="isMobile" class="mobile-buttons">
  <ng-container *ngIf="!dataLoading.isLoading">
    <ion-button (click)="takePicture()" expand="block">
      <ion-icon name="camera"></ion-icon>
  Take Photo
    </ion-button>
    <ion-button *ngIf="allowLibrary" (click)="selectFromLibrary()" expand="block">
      <ion-icon name="image"></ion-icon>
  Choose from Library
    </ion-button>
  </ng-container>
  <div *ngIf="dataLoading.isLoading">
    <ion-spinner name="crescent"></ion-spinner>
    <div class="loading-message">{{ dataLoading.message }}</div>
  </div>
</div> 